import { OverlayController } from "./OverlayController"

import Overlay from "./Overlay.svelte"

const openOverlay = OverlayController.openOverlay
const closeOverlay = OverlayController.closeOverlay

export { openOverlay, closeOverlay, Overlay, OverlayController }
export * from "./variants"
export * from "./variants/types"
